export default __webpack_public_path__ + "static/partner12-03c778e277f6e3b150149fab45c59b0e.png";